import moment from 'moment'

export const getTimeGreeting = () => {
  const hour = moment().hour()

  if (hour < 12) return 'Good morning'
  if (hour < 17) return 'Good afternoon'
  return 'Good evening'
}
